// src/api/aiService.js

const AI_WORKER_URL = process.env.REACT_APP_AI_WORKER_URL;

if (!AI_WORKER_URL) {
  console.error("REACT_APP_AI_WORKER_URL is not set");
}

export async function generateAIContent(userPrompt, type = "generic") {
  const trimmed = (userPrompt || "").trim();
  if (!trimmed) {
    throw new Error("Please describe what this link is for.");
  }

  const controller = new AbortController();

  const timeout = setTimeout(() => {
    controller.abort();
  }, 12000);

  try {
    const res = await fetch(`${AI_WORKER_URL}/generate-content`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ userPrompt: trimmed, type }),
      signal: controller.signal,
      credentials: "omit",
    });

    if (!res.ok) {
      const errBody = await res.json().catch(() => null);
      const msg =
        errBody?.error ||
        (res.status >= 500
          ? "AI service is temporarily unavailable."
          : "Could not generate suggestions.");
      throw new Error(msg);
    }

    const data = await res.json();

    if (
      !data ||
      typeof data.suggestedName !== "string" ||
      typeof data.suggestedNotes !== "string"
    ) {
      throw new Error("AI returned an unexpected response.");
    }

    return {
      suggestedName: data.suggestedName.trim(),
      suggestedNotes: data.suggestedNotes.trim(),
    };
  } catch (err) {
    if (err.name === "AbortError") {
      throw new Error("AI request timed out. Please try again.");
    }
    throw err;
  } finally {
    clearTimeout(timeout);
  }
}
